import environment from "src/utils/environment";
const remote = window.require("@electron/remote");

export default function updateWindowSize() {
  if (environment.isBrowser) return;
  const browserWindow = remote.getCurrentWindow();

  // Setting minimum size first before setting the size itself is said to be fix for linux systems,
  // where setting the size wouldn't resize the window. But of course, that stopped working for
  // some reason and the exact opposite works instead.

  // browserWindow.setMinimumSize(
  //   remote.getGlobal("appMinWidth"),
  //   remote.getGlobal("appMinHeight")
  // );

  const shouldUpdate = !browserWindow.isResizable();

  if (shouldUpdate) {
    browserWindow.setSize(
      remote.getGlobal("appMinWidth"),
      remote.getGlobal("appMinHeight"),
      true
    );
    browserWindow.setResizable(true);
  }

  browserWindow.setMinimumSize(
    remote.getGlobal("appMinWidth"),
    remote.getGlobal("appMinHeight")
  );
}
